module.exports = __webpack_public_path__ + "img/sign-up-background.caa5eec7.jpg";